import {
  CheckboxListInput,
  InputValue,
  WidgetButtonsInput,
  RadioListInput,
  TextInput
} from "@closerplatform/spinner-openapi";

export enum WidgetInputType {
  RadioButtons,
  MultipleButtons,
  RadioList,
  CheckboxList,
  Text
}

export type UserAnswers = {
  [inputName: string]: InputValue;
};
/** New input type -> Add to this union  */
export type WidgetInputRadioButtons = WidgetButtonsInput & { type: WidgetInputType.RadioButtons };
export type WidgetInputMultipleButtons = WidgetButtonsInput & {
  type: WidgetInputType.MultipleButtons;
};
export type WidgetInputRadioList = RadioListInput & { type: WidgetInputType.RadioList };
export type WidgetInputCheckboxList = CheckboxListInput & { type: WidgetInputType.CheckboxList };
export type WidgetInputText = TextInput & { type: WidgetInputType.Text };

export type WidgetInput =
  | WidgetInputRadioButtons
  | WidgetInputMultipleButtons
  | WidgetInputRadioList
  | WidgetInputCheckboxList
  | WidgetInputText;

export interface WidgetInputProps {
  formId: string;
  isSubmitted: boolean;
  userAnswers: UserAnswers;
  input: WidgetInput;
  onChange(inputValue: InputValue): void;
}

export type LimitedWidgetInputProps = Pick<
  WidgetInputProps,
  "onChange" | "userAnswers" | "isSubmitted" | "formId"
>;
